import { intervalToDuration } from "date-fns";

import { formatBackendDateOnly } from "utils/common";

import { DIALER_CALL_STATE_PICKED_UP } from "./constants";
import { SunoDialerState } from "./suno-dialer-slice";

export const WIDGET_BACKGROUND =
  "hsla(273, 37%, 68%, 0.8) 50%, hsla(154, 32%, 62%, 0.9) 100%";

const formatUnit = (value: number | undefined, unit: string) => {
  if (!value) return "";

  return `${value} ${unit}${value > 1 ? "s" : ""}`;
};

export const dateDifferenceText = (dateValue: string | null | undefined) => {
  if (!dateValue) return "just now";
  const formatted = formatBackendDateOnly(dateValue);
  if (!formatted) return "just now";
  const now = new Date();
  const date = new Date(formatted);
  if (Number.isNaN(date.getTime())) return "just now";

  const { years, months, weeks, days } = intervalToDuration({
    start: date,
    end: now,
  });

  if (!years && !months && !weeks && !days) {
    return "today";
  } else if (!years && !months && !weeks && days === 1) {
    return "yesterday";
  } else if (!years && !months && Number(weeks) <= 3) {
    return `${formatUnit(days, "day")} ago`;
  } else if (!years && months) {
    return `${formatUnit(months, "month")} ago`;
  } else if (years) {
    return `${formatUnit(years, "year")} ago`;
  } else {
    return `${formatUnit(days, "day")} ago`;
  }
};

export const getCallWaitingIds = (state: SunoDialerState, ids: string[]) => {
  const details = state.callsQueue.details;

  return ids.filter((id) => details[id].state !== DIALER_CALL_STATE_PICKED_UP);
};

export const isStateValid = (newState: any) => {
  return (
    newState &&
    typeof newState === "object" &&
    newState.displaySettings &&
    typeof newState.displaySettings === "object" &&
    newState.callsQueue &&
    typeof newState.callsQueue === "object" &&
    newState.callsQueue.ids &&
    Array.isArray(newState.callsQueue.ids) &&
    newState.callsQueue.waitingIds &&
    Array.isArray(newState.callsQueue.waitingIds) &&
    newState.callsQueue.details &&
    typeof newState.callsQueue.details === "object"
  );
};

export const normalizePhoneNumber = (phoneNumber?: string) => {
  return (phoneNumber ?? "")
    .replaceAll(" ", "")
    .replaceAll("(", "")
    .replaceAll(")", "")
    .replaceAll("-", "")
    .replace(/^\+1/, ""); // Remove +1 country code
};
